export default __webpack_public_path__ + "cff7be92e9b0d2c11a2d9536557221b9.svg";